/* eslint-disable no-unneeded-ternary */
import React, { memo } from "react";
import PropTypes from "prop-types";
import ContactSales from "../ContactSales";
import Icon from "../Icon";
import Conditional from "../../hocs/Conditional";
import "./styles.scss";
import {
  tealButton,
  whiteOutlineButton,
  sectionHeader,
  whiteChevron,
  defaultChevron,
  mediumText,
} from "../../common/globalStyles";

function getUTMLink(baseLink, sourceAction, utmAppend) {
  return sourceAction.length > 0
    ? `${baseLink}${sourceAction}&${utmAppend}`
    : `${baseLink}${utmAppend}`;
}

const ReadyToGetStarted = ({
  heading,
  content,
  checkList,
  startNowBaseLink,
  getInTouchBaseLink,
  startNowLinkUtmAppend,
  getInTouchLinkUtmAppend,
  utmSourceAction = "",
  contactSalesCTAVisible,
  createAccountCTAName,
  cta,
}) => (
  <section className="ready-to-get-started">
    <div className="container position-relative z-1">
      <div className="row row-no-margin justify-space-between tablet-wrap gap-5">
        <div className="flex flex-col max-w-[717px] gap-5">
          <div className={`${sectionHeader} font-inter`}>{heading}</div>
          <div>
            <p className={`${mediumText} md:max-w-[650px]`}>{content}</p>
          </div>
          <ul className="check-list-round pt-3 sm:gap-[20px]">
            {checkList?.map(({ id, listItem, listitem }) => (
              <li key={id}>
                <span>
                  <Icon
                    name="tick"
                    width="9.21px"
                    height="6.29px"
                    fill="#fff"
                  />
                </span>
                <p className={mediumText}>{listItem || listitem}</p>
              </li>
            ))}
          </ul>
        </div>
        <div className="flex flex-col sm:flex-row gap-5 items-center ">
          <Conditional if={cta?.length > 0}>
            <a
              href={cta?.[0]?.link}
              rel="noopener noreferrer"
              className={tealButton}>
              {cta?.[0]?.label}
              <span className={defaultChevron} />
            </a>
            {contactSalesCTAVisible && (
              <ContactSales
                href={cta?.[1]?.link}
                rel="noopener noreferrer"
                className={whiteOutlineButton}>
                {cta?.[1]?.label}
                <span className={whiteChevron} />
              </ContactSales>
            )}
          </Conditional>
          <Conditional if={cta == null || cta?.length === 0}>
            <a
              href={getUTMLink(
                startNowBaseLink,
                utmSourceAction,
                startNowLinkUtmAppend,
              )}
              rel="noopener noreferrer"
              className={tealButton}>
              {createAccountCTAName ? createAccountCTAName : "Create Account"}
              <span className={defaultChevron} />
            </a>
            {contactSalesCTAVisible && (
              <ContactSales
                href={getUTMLink(
                  getInTouchBaseLink,
                  utmSourceAction,
                  getInTouchLinkUtmAppend,
                )}
                rel="noopener noreferrer"
                className={whiteOutlineButton}>
                Contact Sales
                <span className={whiteChevron} />
              </ContactSales>
            )}
          </Conditional>
        </div>
      </div>
    </div>
  </section>
);

ReadyToGetStarted.propTypes = {
  heading: PropTypes.string,
  content: PropTypes.string,
  checkList: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.number,
      btnColor: PropTypes.string,
    }),
  ),
  startNowBaseLink: PropTypes.string,
  getInTouchBaseLink: PropTypes.string,
  startNowLinkUtmAppend: PropTypes.string,
  getInTouchLinkUtmAppend: PropTypes.string,
  utmSourceAction: PropTypes.string,
  contactSalesCTAVisible: PropTypes.bool,
  createAccountCTAName: PropTypes.string,
  cta: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string.isRequired,
      link: PropTypes.string.isRequired,
    }),
  ),
};

ReadyToGetStarted.defaultProps = {
  createAccountCTAName: "Create Account",
  contactSalesCTAVisible: true,
  utmSourceAction: "",
  heading: `Ready to Get started?`,
  content: `Collect customer payments, make payouts, manage international payments and so much more. Create your account or contact our experts to explore custom solutions.`,
  checkList: [
    {
      id: 0,
      listItem: "Easy onboarding",
    },
    {
      id: 1,
      listItem: "Dedicated account manager",
    },
    {
      id: 2,
      listItem: "API access",
    },
  ],
  startNowBaseLink: "https://merchant.cashfree.com/merchants/signup?",
  getInTouchBaseLink: "/contact-sales?",
  startNowLinkUtmAppend: "action=Sign%20Up&button-id=StartNow_Footer",
  getInTouchLinkUtmAppend:
    "action=Contact%20Sales&button-id=ContactSales_Footer",
  cta: [],
};

export default memo(ReadyToGetStarted);
